import React from 'react';
import { Link } from 'react-router-dom';
import RestaurantMenuRoundedIcon from '@mui/icons-material/RestaurantMenuRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import BrandLogo from '@components/BrandLogo';
import './TwoColumn.scss';

type TwoColumnProps = {
    children: React.ReactNode;
};

const FEATURES = [
    { icon: <RestaurantMenuRoundedIcon />, text: 'Orders, KOT & billing in one flow' },
    { icon: <ReceiptLongRoundedIcon />, text: 'Room billing for hotels & resorts' },
    { icon: <BoltRoundedIcon />, text: 'Real-time ops for your whole team' },
];

export default function TwoColumn({ children }: TwoColumnProps) {
    return (
        <div className="two-column">
            <aside className="two-column__brand" aria-hidden="true">
                <div className="two-column__brand-inner">
                    <Link to="/" className="two-column__logo-link">
                        <BrandLogo className="two-column__logo" alt="" />
                        <h2 className="two-column__brand-name">Khaata POS</h2>
                    </Link>
                    <h3 className="two-column__headline">Billing made simple for hospitality</h3>
                    <p className="two-column__tagline">
                        Manage food orders, room bills, and daily operations from a single modern platform.
                    </p>
                    <ul className="two-column__features">
                        {FEATURES.map((feature) => (
                            <li key={feature.text} className="two-column__feature">
                                {feature.icon}
                                {feature.text}
                            </li>
                        ))}
                    </ul>
                </div>
            </aside>
            <div className="two-column__main">
                <div className="two-column__content">{children}</div>
            </div>
        </div>
    );
}
